/**
 * Safe custom element registration utility.
 *
 * Wraps customElements.define() to prevent NotSupportedError when
 * the same element is registered twice (e.g. CDN + npm import).
 */

const originalDefine = customElements.define.bind(customElements);

/**
 * Override customElements.define to silently skip duplicate registrations.
 * This prevents crashes when platform-shell is loaded both via CDN and npm import.
 */
export function installSafeDefine(): void {
  if ((customElements as any).__moyaSafeDefine) return;

  customElements.define = function (
    name: string,
    constructor: CustomElementConstructor,
    options?: ElementDefinitionOptions
  ): void {
    if (customElements.get(name)) {
      console.debug(`[PlatformShell] Custom element "${name}" already registered, skipping.`);
      return;
    }
    originalDefine(name, constructor, options);
  };

  (customElements as any).__moyaSafeDefine = true;
}
